import Immutable from 'immutable';
import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import OptInBanner from '@bibliocommons/opt-in';
import OptInActions from '../actions/OptInActions';
import { currentUserSelector } from '../selectors/AuthSelector';
import locationShape from 'react-router/lib/PropTypes';

const propTypes = {
  bundleName: PropTypes.string.isRequired,
  feedbackCategory: PropTypes.string.isRequired,
  location: PropTypes.shape(locationShape),
  optedIn: PropTypes.bool,
  optInActions: PropTypes.object.isRequired,
  allowOptOut: PropTypes.bool,
  allowDismiss: PropTypes.bool,
  showAdditionalMessage: PropTypes.bool,
  user: PropTypes.object  // TODO: Create bc user shape proptype.
};

export class OptInContainer extends BcReactComponent {
  render() {
    const { bundleName,
      feedbackCategory,
      location,
      optedIn,
      optInActions,
      optInBanner,
      publicBeta,
      user,
      showAdditionalMessage,
      allowOptOut,
      allowDismiss } = this.props;

    if (!user && !publicBeta) {
      return null;
    }

    return (
      <OptInBanner
        feedbackCategory={feedbackCategory}
        actions={optInActions}
        bundle={bundleName}
        allowOptOut={allowOptOut}
        allowDismiss={allowDismiss}
        optedIn={optedIn}
        showAdditionalMessage={showAdditionalMessage}
        location={location}
        {...optInBanner} />
    );
  }
}

OptInContainer.propTypes = propTypes;

const mapStateToProps = (state, ownProps) => {
  const user = currentUserSelector(state);
  return {
    user,
    optedIn: !!state.getIn(['entities', 'optIn', ownProps.bundleName]) || ownProps.optedIn,
    optInBanner: state.getIn(['optIn', ownProps.bundleName], Immutable.Map()).toObject(),
    feedbackCategory: ownProps.feedbackCategory || ownProps.bundleName,
    publicBeta: ownProps.bundleName === 'nerf_search' && state.getIn(['app', 'featureFlags', 'nerfSearchPublicBeta'])
  };
};

const mapDispatchToProps = dispatch => ({
  optInActions: bindActionCreators(OptInActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(OptInContainer);



// WEBPACK FOOTER //
// ./app/containers/OptInContainer.jsx